<div class="cal-card flex flex-column">
  <div class="cal-toolbar flex flex-wrap align-items-center justify-content-between gap-3 p-3">
    <div class="flex align-items-center gap-3 toolbar-title">
      <div class="date-badge flex flex-column">
        <div class="date-badge__month text-xs-semibold text-gray-700">{{ badgeMonth() }}</div>
        <div class="date-badge__day text-gray-900">{{ badgeDay() }}</div>
      </div>
      <div class="flex flex-column toolbar-heading">
        <div class="toolbar-heading__title display-xs-semibold text-gray-900">{{ titleLabel() }}</div>
        <div class="text-sm-regular text-gray-600">{{ rangeLabel() }}</div>
      </div>
    </div>
    <div class="flex align-items-center gap-2 toolbar-actions">
      <button type="button" class="nav-btn flex align-items-center justify-content-center" (click)="prev()" aria-label="Prethodna nedelja">
        <app-arrow direction="left" stroke="#414651"></app-arrow>
      </button>
      <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.SM" (btnClicked)="today()">
        <div class="text-sm-semibold text-gray-700">Danas</div>
      </app-button>
      <button type="button" class="nav-btn flex align-items-center justify-content-center" (click)="next()" aria-label="Sledeća nedelja">
        <app-arrow direction="right" stroke="#414651"></app-arrow>
      </button>
      <p-select
        [autofocus]="false"
        [ngModel]="view()"
        [options]="viewOptions()"
        optionLabel="label"
        optionValue="value"
        (onChange)="changeView($event.value)"
        styleClass="view-select"
        appendTo="body"
      >
        <ng-template #selectedItem let-item>
          <div class="flex align-items-center" style="gap: 6px; line-height: 1;">
            @if (item.value === 'timeGridWeek') {
              <app-align-top-02 stroke="#181D27" width="12px" height="12px"></app-align-top-02>
            } @else {
              <app-rows-01 stroke="#181D27" width="15px" height="15px"></app-rows-01>
            }
            <span class="text-sm-semibold text-gray-900">{{ item.label }}</span>
          </div>
        </ng-template>
        <ng-template #item let-item>
          <div class="flex align-items-center" style="gap: 6px; line-height: 1;">
            @if (item.value === 'timeGridWeek') {
              <app-align-top-02 stroke="#181D27" width="12px" height="12px"></app-align-top-02>
            } @else {
              <app-rows-01 stroke="#181D27" width="15px" height="15px"></app-rows-01>
            }
            <span class="text-sm-semibold text-gray-900">{{ item.label }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>

  <div class="cal-body flex">
    <div class="cal-grid flex-1">
      <full-calendar #fc [options]="calendarOptions">
        <ng-template #eventContent let-arg>
          <div class="fc-event-card flex flex-column gap-1">
            <div class="text-xs-semibold event-title">{{ arg.event.title }}</div>
            <div class="flex align-items-center gap-1 event-time">
              <app-clock [stroke]="arg.event.textColor || '#414651'" width="0.75rem" height="0.75rem"></app-clock>
              <span class="text-xs-regular event-time__text">{{ formatTimeRange(arg.event.start, arg.event.end) }}</span>
            </div>
          </div>
        </ng-template>
      </full-calendar>
    </div>

    @if (view() === 'timeGridDay') {
      <div class="cal-sidebar flex flex-column gap-4 p-4">
        <p-datepicker
          [autofocus]="false"
          [ngModel]="miniDate()"
          (ngModelChange)="onMiniDateChange($event)"
          [inline]="true"
          [showOtherMonths]="true"
          [selectOtherMonths]="true"
          styleClass="mini-datepicker"
        >
          <ng-template #date let-date>
            <span [class.mini-day--non-working]="isNonWorkingDate(date)">{{ date.day }}</span>
          </ng-template>
        </p-datepicker>

        @if (selectedAppointmentId()) {
          <div class="inline-details flex flex-column">
            <app-appointment-details-content
              [appointmentId]="selectedAppointmentId()"
              (onCancel)="onActionFromInline()"
              (onRescheduled)="onActionFromInline()"
              (onMarkedNoShow)="onActionFromInline()"
            ></app-appointment-details-content>
          </div>
        }
      </div>
    }
  </div>

  <div class="cal-legend flex flex-wrap align-items-center gap-3 px-3 py-2 text-xs-medium text-gray-600">
    @for (item of legend; track item.label) {
      <div class="flex align-items-center gap-1">
        <span class="cal-legend__swatch" [style.background]="item.border"></span>
        {{ item.label }}
      </div>
    }
  </div>
</div>

<app-appointment-details-drawer
  [(visible)]="showDrawer"
  [appointmentId]="drawerAppointmentId()"
  (onCancel)="onActionFromDrawer()"
  (onRescheduled)="onActionFromDrawer()"
  (onMarkedNoShow)="onActionFromDrawer()"
></app-appointment-details-drawer>
